/*
  Graphql API ordering values
*/

import type { SortOrderDirection } from '@@partner:types:graphql'

export const SORT_ORDER_DESC: SortOrderDirection = 0
export const SORT_ORDER_ASC: SortOrderDirection = 1
